const ST1_odds_old = [
  {
    answer2: "option1",
    answer3: "option1",
    answer4: "option1",
    product: "N",
  },
  {
    answer2: "option1",
    answer3: "option1",
    answer4: "option2",
    product: "N",
  },
  {
    answer2: "option1",
    answer3: "option1",
    answer4: "option3",
    product: "O",
  },
  {
    answer2: "option1",
    answer3: "option2",
    answer4: "option1",
    product: "N",
  },
  {
    answer2: "option1",
    answer3: "option2",
    answer4: "option2",
    product: "N",
  },
  {
    answer2: "option1",
    answer3: "option2",
    answer4: "option3",
    product: "O",
  },
  {
    answer2: "option1",
    answer3: "option3",
    answer4: "option2",
    product: "N",
  },
  {
    answer2: "option1",
    answer3: "option3",
    answer4: "option3",
    product: "O",
  },
  
  {
    answer2: "option1",
    answer3: "option3",
    answer4: "option4",
    product: "O",
  },
  {
    answer2: "option2",
    answer3: "option1",
    answer4: "option1",
    product: "N",
  },
  {
    answer2: "option2",
    answer3: "option1",
    answer4: "option2",
    product: "N",
  },
  {
    answer2: "option2",
    answer3: "option1",
    answer4: "option3",
    product: "O",
  },
  {
    answer2: "option2",
    answer3: "option2",
    answer4: "option2",
    product: "N",
  },
  {
    answer2: "option2",
    answer3: "option2",
    answer4: "option3",
    product: "O",
  },
  {
    answer2: "option2",
    answer3: "option2",
    answer4: "option4",
    product: "O",
  },
  {
    answer2: "option2",
    answer3: "option3",
    answer4: "option2",
    product: "N",
  },
  {
    answer2: "option2",
    answer3: "option3",
    answer4: "option3",
    product: "O",
  },
  {
    answer2: "option2",
    answer3: "option3",
    answer4: "option4",
    product: "O",
  },
  {
    answer2: "option3",
    answer3: "option1",
    answer4: "option2",
    product: "N",
  },

  {
    answer2: "option3",
    answer3: "option1",
    answer4: "option3",
    product: "O",
  },

  {
    answer2: "option3",
    answer3: "option1",
    answer4: "option4",
    product: "O",
  },

  {
    answer2: "option3",
    answer3: "option2",
    answer4: "option2",
    product: "N",
  },

  {
    answer2: "option3",
    answer3: "option2",
    answer4: "option3",
    product: "O",
  },

  {
    answer2: "option3",
    answer3: "option2",
    answer4: "option4",
    product: "O",
  },

  {
    answer2: "option3",
    answer3: "option3",
    answer4: "option2",
    product: "N",
  },

  {
    answer2: "option3",
    answer3: "option3",
    answer4: "option3",
    product: "O",
  },

  {
    answer2: "option3",
    answer3: "option3",
    answer4: "option4",
    product: "O",
  }
];

export default ST1_odds_old;
